import axios from 'axios';
import parsePhoneNumber from 'libphonenumber-js';

// use USA's phone country code as a default one
export const DEFAULT_COUNTRY_CODE = '+1';
export const DEFAULT_COUNTRY = 'US';

export const getCountryCallingCode = async(): Promise<string> => {
  return await axios
    .get('https://ipapi.co/json/')
    .then((response) => {
      return response.data.country_calling_code;
    })
    .catch((error) => {
      console.log(error);
      return DEFAULT_COUNTRY_CODE;
    });
};

export const validateCountryCodeLength = (value: string) => {
  if (value.length <= 1) {
    return {
      message: 'Enter a valid country code.',
      status: 'error',
    }
  }
};

export const validatePhoneNumberLength = (value) => {
  if (value.length <= 1) {
    return {
      message: 'Enter a valid phone number.',
      status: 'error',
    }
  }
};

export const getParsedCountryCode = (value: string): string => {
  return value.startsWith('+') ? value : `+${value}`;
};

export const getParsedPhoneNumberWithoutCountryCode = (countryCode: string, phoneNumber: string): string => {
  const parsedPhoneNumber = parsePhoneNumber(countryCode + phoneNumber);

  if (parsedPhoneNumber) {
    const internationalPhoneNumber = parsedPhoneNumber.formatInternational();
    let amountOfSpacesInCountryCode = (internationalPhoneNumber.slice(0, countryCode.length).match(/ /g) || []).length;

    return internationalPhoneNumber.slice(countryCode.length + amountOfSpacesInCountryCode).trim();
  } else {
    return phoneNumber;
  }
};

export const getParsedPhoneNumber = (number: string): string => {
  let val = number.startsWith('+') ? number : `+${number}`;
  const parsedNumber = parsePhoneNumber(val);

  if (parsedNumber) {
    val = parsedNumber.formatInternational();
  }

  return val;
};

export const getCountryByPhone = (phone) => {
  const phoneNumber = parsePhoneNumber(phone);

  return phoneNumber?.country || DEFAULT_COUNTRY;
};
